
import React, { } from 'react';
import './input.css'

const Input = ({ title, placeholder, isIcon }) => {

  return (

    <>

      {!isIcon ? (
        <>
          <div className="container_input">
            <div className="input_title">{title}</div>
            <input type="text" placeholder={placeholder} className="input_placeholder" />
          </div>
        </>
      ) : (<>
        <div className="container_input">
          <div className="input_title">{title}</div>
          <input type="text" placeholder={placeholder} className="input_placeholder_revers" />
        </div>
      </>)}
    </>

  )
}

export default Input;